var Datasource = /** @class */ (function () {
    function Datasource(_a) {
        var id = _a.id, name = _a.name, datasetId = _a.datasetId, tables = _a.tables;
        this.id = id;
        this.name = name;
        this.datasetId = datasetId;
        this.tables = tables;
    }
    Datasource.fromJSON = function (json) {
        var _a = Object.assign({}, json), id = _a.id, _b = _a.attributes, name = _b.name, dataset_id = _b.dataset_id, tables = _b.tables;
        if (typeof id !== 'string')
            throw new Error('id must be a string');
        if (typeof name !== 'string')
            throw new Error('name must be a string');
        if (typeof dataset_id !== 'string')
            throw new Error('name must be a string');
        return new Datasource({
            id: id,
            name: name,
            datasetId: dataset_id,
            tables: tables.map(function (e) { return DatasourceTable.fromJSON(e); }),
        });
    };
    return Datasource;
}());
var DatasourceTable = /** @class */ (function () {
    function DatasourceTable(_a) {
        var tableName = _a.tableName, countNumber = _a.countNumber;
        this.tableName = tableName;
        this.countNumber = countNumber;
    }
    DatasourceTable.fromJSON = function (json) {
        var _a = Object.assign({}, json), table_name = _a.table_name, count_number = _a.count_number;
        return new DatasourceTable({
            tableName: table_name,
            countNumber: count_number,
        });
    };
    return DatasourceTable;
}());
export default Datasource;
